const ACCESS_DENIED = 'access_denied';

export const NO_SECTION_MESSAGE =
  'Tu usuario no tiene acceso a ninguna sección del CMS. Contacta con un administrador.';

/**
 * Mensaje para la pantalla de login cuando se ha cerrado la sesión por falta
 * de permisos. Va en sessionStorage porque el cierre ocurre en el Middleware,
 * antes de pintar el login.
 */
export const setAccessDeniedMessage = (message) => {
  sessionStorage.setItem(ACCESS_DENIED, message);
}

/** Devuelve el mensaje pendiente y lo consume (se muestra una sola vez). */
export const takeAccessDeniedMessage = () => {
  const message = sessionStorage.getItem(ACCESS_DENIED);
  sessionStorage.removeItem(ACCESS_DENIED);
  return message;
}
